﻿import { PanelistCurrency } from '@/utils/types';

interface PanelCurrencyAmountParams {
  panelistCurrencyAmount: number;
  currencyMinorUnits?: number;
  panelistCurrency?: PanelistCurrency | null;
}

export const getPanelCurrencyAmount = ({
  panelistCurrencyAmount,
  currencyMinorUnits,
  panelistCurrency,
}: PanelCurrencyAmountParams): {
  value: number;
  display: string;
} => {
  const decimals =
    currencyMinorUnits ?? panelistCurrency?.display_decimals ?? 0;

  const rate = panelistCurrency?.currency_rate ?? 1;

  const value = panelistCurrency?.is_custom_currency
    ? panelistCurrencyAmount * rate
    : panelistCurrencyAmount;

  const numberValue = typeof value === 'string' ? parseFloat(value) : value;

  return {
    value: numberValue,
    display: numberValue.toFixed(decimals),
  };
};
